import React from 'react'

export const IcoPdcaLink = ({ style = {} }) => {
  return (
    <svg className='icon-pdca-link' viewBox='0 0 32 32' style={style}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        fill="#2ab8ac"
        d='M16 2
           C15.448 2 15 2.448 15 3V6.108
           C11.118 6.563 7.982 9.619 7.392 13.5H4
           C3.448 13.5 3 13.948 3 14.5V17.5
           C3 18.052 3.448 18.5 4 18.5H7.392
           C7.982 22.381 11.118 25.437 15 25.892V29
           C15 29.552 15.448 30 16 30H19
           C19.552 30 20 29.552 20 29V25.892
           C23.882 25.437 27.018 22.381 27.608 18.5H31
           C31.552 18.5 32 18.052 32 17.5V14.5
           C32 13.948 31.552 13.5 31 13.5H27.608
           C27.018 9.619 23.882 6.563 20 6.108V3
           C20 2.448 19.552 2 19 2H16ZM17.5 10.02
           C20.945 10.02 23.74 12.815 23.74 16.26
           C23.74 19.705 20.945 22.5 17.5 22.5
           C14.055 22.5 11.26 19.705 11.26 16.26
           C11.26 12.815 14.055 10.02 17.5 10.02ZM17.5 13.2
           C19.189 13.2 20.56 14.571 20.56 16.26
           C20.56 17.949 19.189 19.32 17.5 19.32
           C15.811 19.32 14.44 17.949 14.44 16.26
           C14.44 14.571 15.811 13.2 17.5 13.2Z'
      />
    </svg>
  )
}